<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-close"
    viewBox="0 0 32 32"
  >
    <line
      id="XMLID_2_"
      fill="#FFFFFF"
      stroke="#030104"
      stroke-miterlimit="10"
      x1="0"
      y1="0"
      x2="32"
      y2="32"
    />
    <line
      id="XMLID_1_"
      fill="#FFFFFF"
      stroke="#030104"
      stroke-miterlimit="10"
      x1="32"
      y1="0"
      x2="0"
      y2="32"
    />
  </svg>
</template>
<script>
export default {};
</script>
